import { c as _c } from "react/compiler-runtime";
import { ALL_SOURCES, LEGACY_SOURCES, SOURCES } from '@repo/sdk/constants';
import { Field, FieldError, Select, SelectContent, SelectItem, SelectTrigger, SelectValue, selectVariant, Spinner } from '@repo/ui/components';
import { cn, VariantProps } from '@repo/ui/lib/utils';
import { ComponentProps } from 'react';
import { useFieldContext } from '../../lib/form-context.ts';
export const FormSourceSelect = t0 => {
  const $ = _c(31);
  const {
    "data-testid": dataTestId,
    isPending: t1,
    placeholder: t2,
    variant: t3
  } = t0;
  const isPending = t1 === undefined ? false : t1;
  const placeholder = t2 === undefined ? "" : t2;
  const variant = t3 === undefined ? "default" : t3;
  const field = useFieldContext();
  let t4;
  if ($[0] !== field.state.value) {
    t4 = LEGACY_SOURCES.find(source => source.slug === field.state.value);
    $[0] = field.state.value;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const legacyOption = t4;
  let t5;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = ALL_SOURCES.map(_temp);
    $[2] = t5;
  } else {
    t5 = $[2];
  }
  let t6;
  if ($[3] !== field) {
    t6 = val => val && field.handleChange(val);
    $[3] = field;
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  const t7 = field.state.value;
  let t8;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = cn("flex w-full justify-between gap-2 p-0 text-base data-[size=default]:h-6");
    $[5] = t8;
  } else {
    t8 = $[5];
  }
  const t9 = dataTestId ?? "form-source-select-trigger";
  let t10;
  if ($[6] !== placeholder) {
    t10 = <SelectValue placeholder={placeholder} data-sentry-element="SelectValue" data-sentry-source-file="form-source-select.tsx" />;
    $[6] = placeholder;
    $[7] = t10;
  } else {
    t10 = $[7];
  }
  let t11;
  if ($[8] !== isPending) {
    t11 = isPending && <Spinner className="text-muted-foreground ml-auto size-4" />;
    $[8] = isPending;
    $[9] = t11;
  } else {
    t11 = $[9];
  }
  let t12;
  if ($[10] !== t10 || $[11] !== t11 || $[12] !== t9 || $[13] !== variant) {
    t12 = <SelectTrigger className={t8} data-testid={t9} variant={variant} data-sentry-element="SelectTrigger" data-sentry-source-file="form-source-select.tsx">{t10}{t11}</SelectTrigger>;
    $[10] = t10;
    $[11] = t11;
    $[12] = t9;
    $[13] = variant;
    $[14] = t12;
  } else {
    t12 = $[14];
  }
  let t13;
  if ($[15] !== legacyOption) {
    t13 = legacyOption && <SelectItem data-testid={`form-source-select-option-${legacyOption.slug}`} disabled={true} key={legacyOption.slug} value={legacyOption.slug}>{legacyOption.name}</SelectItem>;
    $[15] = legacyOption;
    $[16] = t13;
  } else {
    t13 = $[16];
  }
  let t14;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = SOURCES.map(_temp2);
    $[17] = t14;
  } else {
    t14 = $[17];
  }
  let t15;
  if ($[18] !== t13) {
    t15 = <SelectContent data-sentry-element="SelectContent" data-sentry-source-file="form-source-select.tsx">{t13}{t14}</SelectContent>;
    $[18] = t13;
    $[19] = t15;
  } else {
    t15 = $[19];
  }
  let t16;
  if ($[20] !== field.state.value || $[21] !== isPending || $[22] !== t12 || $[23] !== t15 || $[24] !== t6) {
    t16 = <div className="relative"><Select disabled={isPending} items={t5} onValueChange={t6} value={t7} data-sentry-element="Select" data-sentry-source-file="form-source-select.tsx">{t12}{t15}</Select></div>;
    $[20] = field.state.value;
    $[21] = isPending;
    $[22] = t12;
    $[23] = t15;
    $[24] = t6;
    $[25] = t16;
  } else {
    t16 = $[25];
  }
  let t17;
  if ($[26] !== field.state.meta.errors) {
    t17 = <FieldError errors={field.state.meta.errors} data-sentry-element="FieldError" data-sentry-source-file="form-source-select.tsx" />;
    $[26] = field.state.meta.errors;
    $[27] = t17;
  } else {
    t17 = $[27];
  }
  let t18;
  if ($[28] !== t16 || $[29] !== t17) {
    t18 = <Field className="gap-1" data-sentry-element="Field" data-sentry-component="FormSourceSelect" data-sentry-source-file="form-source-select.tsx">{t16}{t17}</Field>;
    $[28] = t16;
    $[29] = t17;
    $[30] = t18;
  } else {
    t18 = $[30];
  }
  return t18;
};
function _temp(source_0) {
  return {
    label: source_0.name,
    value: source_0.slug
  };
}
function _temp2(source_1) {
  return <SelectItem data-testid={`form-source-select-option-${source_1.slug}`} key={source_1.slug} value={source_1.slug}>{source_1.name}</SelectItem>;
}